import z from 'zod';

export const userGameSessionStatsSchema = z
    .object({
        first_session_at: z.string().nullable(),
        last_session_at: z.string().nullable(),
        total_sessions: z.number(),
        total_play_time_seconds: z.number(),
        total_events: z.number(),
        sessions_with_location: z.number(),
    })
    .describe('UserGameSessionStats');
export type UserGameSessionStats = z.infer<typeof userGameSessionStatsSchema>;

export const userGameSessionStatsResponseSchema = z
    .object({ data: userGameSessionStatsSchema })
    .describe('UserGameSessionStatsResponse');
export type UserGameSessionStatsResponse = z.infer<typeof userGameSessionStatsResponseSchema>;
